import { CaretRight } from "@phosphor-icons/react";
import { useMemo, useState } from "react";

import MobileListTable from "common/components/MobileListTable";
import { Button } from "common/components/ui/Button";

import TokenDetails from "./TokenDetails";

import type { ColumnDef } from "@tanstack/react-table";
import type { ApiToken } from "../../../types";

interface MobileListProps {
  tokens: ApiToken[];
}

export default function MobileList({ tokens }: MobileListProps) {
  const [actionState, setActionState] = useState<{
    isOpen: boolean;
    selectedToken: ApiToken;
  }>({ isOpen: false, selectedToken: undefined });

  const { isOpen, selectedToken } = actionState;

  const handleRowClick = (apiToken: ApiToken) => {
    setActionState({ isOpen: true, selectedToken: apiToken });
  };

  const columns: ColumnDef<ApiToken>[] = useMemo(
    () => [
      {
        id: "keyName",
        header: "Key name",
        cell: ({
          row: {
            original: { name },
          },
        }) => (
          <span className="line-clamp-1 break-words text-start text-sm-bold">
            {name}
          </span>
        ),
      },
      {
        id: "permissions",
        header: "Permission",
        cell: ({
          row: {
            original: { read: canRead, write: canWrite },
          },
        }) => {
          const permissions = canRead && canWrite ? "All" : "Read only";

          return (
            <span className="capitalize text-black-700">{permissions}</span>
          );
        },
      },
      {
        id: "actions",
        cell: () => (
          <Button intent="labelIcon" size="sm" variant="ghost-black">
            <CaretRight />
          </Button>
        ),
      },
    ],
    [],
  );

  return (
    <>
      <MobileListTable
        data={tokens}
        isLoading={false}
        columns={columns}
        onRowClick={handleRowClick}
      />
      {selectedToken && (
        <TokenDetails
          selectedToken={selectedToken}
          isOpen={isOpen}
          setIsOpen={() => setActionState({ ...actionState, isOpen: false })}
        />
      )}
    </>
  );
}
